// extracted by mini-css-extract-plugin
export var alignCenter = "_bg-d";
export var bannerShown = "_bg-6";
export var buttonContent = "_bg-0";
export var cardList = "_bg-1";
export var centerContent = "_bg-2";
export var chevron = "_bg-3";
export var closePanelButton = "_bg-k";
export var conversationContextContainer = "_bg-l";
export var conversationDetailContainer = "_bg-4";
export var detailWrapper = "_bg-7";
export var dropdownButton = "_bg-e";
export var dropdownTitle = "_bg-9";
export var fullHeight = "_bg-5";
export var hidden = "_bg-a";
export var icon = "_bg-b";
export var mergeSuggestionWrapper = "_bg-m";
export var panel = "_bg-i";
export var portalButtonsWrapper = "_bg-c";
export var right = "_bg-j";
export var tableSummaryContainer = "_bg-8";
export var tableSummaryHeader = "_bg-g";
export var threeDotsButton = "_bg-f";
export var wide = "_bg-h";